'use strict';

/**
 * Can handle multiple dispatcher instances. But best practice is to have each
 * application instantiate and use one global dispatcher.
 */

var config = require('../config');

var DispatcherUtil = function ($timeout, EventUtil) {
  
  var dispatchers = {};

  function Dispatcher (id) {
    this.id = id || config.DISPATCHER_ID;
    EventUtil.EventEmitter.call(this);
  }

  Dispatcher.get = function (id) {
    var dispatcher;

    id = id || config.DISPATCHER_ID;
    dispatcher = dispatchers[id];

    if (!dispatcher) {
      dispatcher = dispatchers[id] = new Dispatcher(id);
    }

    return dispatcher;
  };

  Dispatcher.getEventName = function (action) {
    var name = action.$name;
    var namespace = action.$namespace;
    return [namespace, name].join(':');
  };

  Dispatcher.prototype = Object.create(EventUtil.EventEmitter.prototype);
  Dispatcher.prototype.constructor = Dispatcher;


  // ## Add aliases to closer resemble Flux Dispatcher API
  
  Dispatcher.prototype.dispatch = function (action) {
    var eventname = Dispatcher.getEventName(action);
    this.emit(eventname, action);
  };

  /**
   * Dispatches the event on the next $digest cycle. It is separate from the 
   * standard 'dispatch' for performance reasons
   */
  Dispatcher.prototype.dispatchNext = function () {
    console.warn('DEPRECATED: Same as `dispatch` now');
    this.dispatch.apply(this, arguments);
  };

  /**
   * Register an Action+Handler combination with the Dispatcher
   */
  Dispatcher.prototype.register = function (action, handler) {
    
    if (!action ||
        typeof action !== 'object' ||
        !action.$name || 
        !action.$namespace) {

      console.error(action);
      throw new Error('Bad Parameters: Cannot register action with dispatcher');
    }

    var eventname = Dispatcher.getEventName(action);
    this.addListener.call(this, eventname, handler);
  };
  
  Dispatcher.prototype.unregister = Dispatcher.prototype.removeListener;

  return Dispatcher;
};

DispatcherUtil.$inject = ['$timeout', 'sbFluxEvent'];
module.exports = DispatcherUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/lib/Dispatcher.js